/* eslint-disable unicorn/consistent-destructuring */
import angular from 'angular';
import _ from 'lodash-es';
import {
	Keymaps,
	LanguageExtensions,
	Plugins,
	ThemeExtensions,
} from '@knitiv/code-editor';
import kformUtils from '../../utils/kform-utils';
import controller from './select.controller';
import template from './select.html';
import Card from '~/scripts/services/model/card';
import SelectComponent from './select.component';

const selectConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('select', {
		title: 'Select',
		template: (/** @type {any} */ $scope) => {
			if ($scope.component.validate?.card && !($scope.component.validate.card instanceof Card)) {
				$scope.component.validate.card = new Card($scope.component.validate.card);
			}
			return $scope.component.validate?.card?.isMultiple()
				? template.replace('<ui-select', '<ui-select multiple')
				: template;
		},
		tableView(/** @type {any} */ data, /** @type {any} */ options) {
			const getItem = (/** @type {any} */ itemData) => {
				switch (options.component.dataSrc) {
				case 'nodes': {
					for (const item of options.component.data.values) {
						if (item.kid === itemData) {
							// eslint-disable-next-line no-param-reassign
							itemData = item;
						}
					}
					return itemData;
				}
				case 'values': {
					for (const item of options.component.data.values) {
						if (item.value === itemData) {
							// eslint-disable-next-line no-param-reassign
							itemData = item;
						}
					}
					return itemData;
				}
				case 'json': {
					if (options.component.valueProperty) {
						let selectItems;
						try {
							selectItems = angular.fromJson(options.component.data.json);
						}
						catch {
							selectItems = [];
						}
						for (const item of selectItems) {
							if (item[options.component.valueProperty] === itemData) {
								// eslint-disable-next-line no-param-reassign
								itemData = item;
							}
						}
					}
					return itemData;
				}
				default: {
					return itemData;
				}
				}
			};
			if (options.component.validate?.card?.isMultiple() && Array.isArray(data)) {
				// eslint-disable-next-line unicorn/no-array-callback-reference
				return data.map(getItem)
					// eslint-disable-next-line unicorn/no-array-reduce
					.reduce((previous, item) => {
						const value = typeof item === 'object' ? options.$interpolate(options.component.template)({ item }) : item;
						return (previous === '' ? '' : ', ') + value;
					}, '');
			}

			const item = getItem(data);
			return typeof item === 'object' ? options.$interpolate(options.component.template)({ item }) : item;
		},
		controller,
		selectable:                 true,
		settings:                   new SelectComponent(),
		icon:                       'fa fa-th-list',
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/select/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/select/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		onEdit: /* @ngInject */     (/** @type {any} */ $scope) => {
			$scope.dataSources = {
				nodes:  'Nodes',
				values: 'Values',
				json:   'Raw JSON',
				custom: 'Custom',
			};
			$scope.resources = [];
			$scope.resourceFields = [];

			$scope.onEditorSetup = () => [
				ThemeExtensions.oneLight,
				LanguageExtensions.json(),

				Plugins.FOLD_GUTTERS(),
				Plugins.MATCH_BRACKETS(),
				Plugins.AUTOCOMPLETION(),
				Plugins.CLOSE_BRACKETS(),
				Plugins.DRAW_SELECTION(),
				Plugins.DROP_CURSOR(),
				Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
				Plugins.HIGHLIGHT_SELECTION_MATCHES(),
				Plugins.HIGHLIGHT_SPECIAL_CHARS(),
				Plugins.HISTORY(),
				Plugins.INDENT_ON_INPUT(),
				Plugins.MULTIPLE_CURSORS(),
				Plugins.RECTANGULAR_SELECTION(),
				Plugins.LINE_NUMBERS(),
				Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
				// onChange,
			];

			// Returns only input fields we are interested in.
			const getInputFields = (/** @type {any} */ components) => {
				/** @type {any[]} */
				const fields = [];
				kformUtils.eachComponent(components, (/** @type {any} */ component) => {
					if (
						component.key
						&& component.input
						&& component.type !== 'button'
						&& component.key !== $scope.component.key
					) {
						const comp = _.clone(component);
						if (!comp.label) {
							comp.label = comp.key;
						}
						fields.push(comp);
					}
				});
				return fields;
			};

			$scope.formFields = [
				{
					label: 'Any Change',
					key:   'data',
				},
				...getInputFields($scope.form.components),
			];

			$scope.$watch('component.dataSrc', (/** @type {any} */ source, /** @type {any} */ previousSource) => {
				if (source !== previousSource) {
					$scope.component.template = '<span>{{ item.label }}</span>';
				}
			});

			// Update other parameters when the value property changes.
			$scope.currentValueProperty = $scope.component.valueProperty;
		},
	});
};
export default angular.module('app')
	.config(selectConfig);
